// src/CameraContext.jsx
import { createContext, useState } from "react";
import { getRegisteredCameras, editCamera as apiEditCamera, deleteCamera as apiDeleteCamera } from "./Api";

export const CameraContext = createContext();

export const CameraProvider = ({ children }) => {
  const [cameras, setCameras] = useState([]);

  const addCamera = (camera) =>
    setCameras((prev) => [...prev, { id: prev.length + 1, ...camera }]);

  const refreshCameras = async () => {
    try {
      const registeredCameras = await getRegisteredCameras();
      setCameras(registeredCameras);
    } catch (error) {
      console.error("Failed to refresh cameras:", error);
    }
  };

  const editCamera = async (cameraId, cameraData) => {
    try {
      const updatedCamera = await apiEditCamera(cameraId, cameraData);
      setCameras((prev) => 
        prev.map((cam) => cam.id === cameraId ? { ...cam, ...updatedCamera } : cam)
      );
      return updatedCamera;
    } catch (error) {
      console.error("Failed to edit camera:", error);
      throw error;
    }
  };

  const deleteCamera = async (cameraId) => {
    try {
      await apiDeleteCamera(cameraId);
      setCameras((prev) => prev.filter((cam) => cam.id !== cameraId));
    } catch (error) {
      console.error("Failed to delete camera:", error);
      throw error;
    }
  };

  return (
    <CameraContext.Provider value={{ 
      cameras, 
      addCamera, 
      editCamera, 
      deleteCamera, 
      refreshCameras 
    }}>
      {children}
    </CameraContext.Provider>
  );
};
